export default "__VITE_ASSET__IAjfxtyh__"